/* eslint-disable import/prefer-default-export */
import { defineStore } from 'pinia';
import router from '@/router';

import { useInitialize } from '@views/composables/use-initialize';
import { resetTenantSpecificStores } from '@/stores';
import { ENTRY_POINTS } from '@constants/entry-points';

type TenantAppType = {
  isInitialized: boolean;
};

const initialState = (): TenantAppType => ({
  isInitialized: false,
});

export const useTenantAppStore = defineStore({
  id: 'tenant-app-state',
  state: initialState,
  actions: {
    $reset() {
      Object.assign(this, initialState());
    },
    async initialize(): Promise<void> {
      if (this.isInitialized) return;

      const { initializeTenantApp } = useInitialize();
      try {
        await initializeTenantApp();
        this.isInitialized = await true;
      } catch (error) {
        console.error(error);
        resetTenantSpecificStores();
        router.push(ENTRY_POINTS.PATH.USER_HOME());
      }
    },
  },
});
